// stockApi.js
// src/features/stock/services/stockApi.js
import httpClient from '../../../shared/services/httpClient';

const stockApi = {
  // Stock Items
  getStockItems: (params = {}) => {
    return httpClient.get('/stock/medicines', { params });
  },

  getStockItem: (id) => {
    return httpClient.get(`/stock/medicines/${id}`);
  },

  createStockItem: (data) => {
    return httpClient.post('/stock/medicines', data);
  },

  updateStockItem: (id, data) => {
    return httpClient.put(`/stock/medicines/${id}`, data);
  },

  deleteStockItem: (id) => {
    return httpClient.delete(`/stock/medicines/${id}`);
  },

  bulkDeleteStockItems: (ids) => {
    return httpClient.post('/stock/medicines/bulk-delete', { ids });
  },

  // Stock Movements
  getStockMovements: (params = {}) => {
    return httpClient.get('/stock/movements', { params });
  },

  createStockMovement: (data) => {
    return httpClient.post('/stock/movements', data);
  },

  getStockMovementsByItem: (itemId, params = {}) => {
    return httpClient.get(`/stock/stock/movements/${itemId}`, { params });
  },

  // Stock Categories
  getStockCategories: () => {
    return httpClient.get('/stock/categories');
  },

  createStockCategory: (data) => {
    return httpClient.post('/stock/categories', data);
  },

  // Stock Reports
  getStockReport: (params = {}) => {
    return httpClient.get('/stock/reports/inventory', { params });
  },

  getExpiringStock: (params = {}) => {
    return httpClient.get('/stock/reports/expiring', { params });
  },

  getLowStockReport: (params = {}) => {
    return httpClient.get('/stock/reports/low-stock', { params });
  },

  // Stock Alerts
  getStockAlerts: () => {
    return httpClient.get('/stock/alerts');
  },

  resolveStockAlert: (alertId) => {
    return httpClient.post(`/stock/alerts/${alertId}/resolve`);
  },

  // Stock Count
  startStockCount: (data) => {
    return httpClient.post('/stock/counts', data);
  },

  updateStockCount: (countId, data) => {
    return httpClient.put(`/stock/counts/${countId}`, data);
  },

  completeStockCount: (countId) => {
    return httpClient.post(`/stock/counts/${countId}/complete`);
  },

  // Batch Operations
  importStock: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return httpClient.post('/stock/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  exportStock: (params = {}) => {
    return httpClient.get('/stock/export', { 
      params, 
      responseType: 'blob' 
    });
  },
};

export default stockApi;